import React, {Component} from 'react'
import {Field, reduxForm} from 'redux-form'
import {connect} from 'react-redux'
import * as actions from '../../actions/venue_edit'

const form = reduxForm({
  form: 'venueedit',
  validate,
})

const renderField = (
  {input, label, type, meta: {asyncValidating, touched, error}},
) => (
  <div>
    <label>{label}</label>
    <div className={asyncValidating ? 'async-validating' : ''}>
      <input
        {...input}
        type={type}
        placeholder={label}
        className="form-control"
      />
      {touched && error && <div className="error">{error}</div>}
    </div>
  </div>
)

function validate(formProps) {
  const errors = {}

  if (!formProps.name) {
    errors.name = 'Please enter a venue name'
  }

  if (!formProps.address) {
    errors.address = 'Please enter a venue address'
  }

  if (!formProps.city) {
    errors.city = 'Please enter a venue city'
  }

  if (!formProps.postcode) {
    errors.postcode = 'Please enter a postcode'
  }

  if (!formProps.country) {
    errors.country = 'Please enter a country'
  }

  return errors
}

export class VenueEdit extends Component {
  constructor(props) {
    super(props)
    this.state = {}

    this.onFormChange = this.handleChange.bind(this)
  }

  componentDidMount() {
    this.props.getVenue(this.props.params.id).then(venue => {
      console.log('VENUE: ' + this.props.venue)
      this.handleInitialize()
    })
  }

  handleInitialize() {
    //console.log('props: ' +this.props.venue.name)
    const initData = {
      id: this.props.venue._id,
      name: this.props.venue.name,
      address: this.props.venue.address,
      city: this.props.venue.city,
      postcode: this.props.venue.postcode,
      country: this.props.venue.country,
      location: this.props.venue.location,
      latitude: this.props.venue.location.coordinates[0],
      longitude: this.props.venue.location.coordinates[1],
    }

    this.props.initialize(initData)
    this.setState(initData)
  }

  handleFormSubmit(formProps) {
    console.log('state: ' + JSON.stringify(this.state))
    console.log('formProps: ' + JSON.stringify(formProps))
    this.props.updateVenue(this.state)
  }

  handleChange(e) {
    var currProp = e.target.name
    switch (currProp) {
      case 'name':
        this.setState({
          name: e.target.value,
        })
        break
      case 'address':
        this.setState({
          address: e.target.value,
        })
        break
      case 'city':
        this.setState({
          city: e.target.value,
        })
        break
      case 'postcode':
        this.setState({
          postcode: e.target.value,
        })
        break
      case 'country':
        this.setState({
          country: e.target.value,
        })
        break
      case 'location':
        const location = {type: 'Point', coordinates: [e.target.value]}
        this.setState({
          location: location,
        })
        break
      case 'latitude':
        const lat = {
          type: 'Point',
          coordinates: [
            Number(e.target.value),
            this.state.location.coordinates[0],
          ],
        }
        console.log('lat: ' + JSON.stringify(lat))
        this.setState({
          location: lat,
        })
        break
      case 'longitude':
        const lng = {
          type: 'Point',
          coordinates: [
            this.state.location.coordinates[1],
            Number(e.target.value),
          ],
        }
        console.log('lng: ' + JSON.stringify(lng))
        this.setState({
          location: lng,
        })
        break
      default:
      // nothing
    }
  }

  renderAlert() {
    if (this.props.errorMessage) {
      return (
        <div className="alert alert-danger">
          <strong>Oops!</strong> {this.props.errorMessage}
        </div>
      )
    }
  }

  render() {
    const {handleSubmit} = this.props

    if (this.props.loading) {
      return (
        <div className="alert alert-success" role="alert">
          <strong>loading...</strong>
        </div>
      )
    } else {
      return (
        <div>
          <form
            onSubmit={handleSubmit(this.handleFormSubmit.bind(this))}
            onChange={e => this.handleChange(e)}
          >
            <button action="submit" className="btn btn-success float-xs-right">
              Update Venue
            </button>
            <blockquote className="blockquote">
              <h1>Edit Venue</h1>
            </blockquote>
            <div className="well">
              <fieldset className="form-group">
                <Field
                  name="name"
                  type="text"
                  component={renderField}
                  label="Venue Name"
                />
              </fieldset>
              <fieldset className="form-group">
                <Field
                  name="address"
                  type="text"
                  component={renderField}
                  label="Venue Address"
                />
              </fieldset>
              <fieldset className="form-group">
                <Field
                  name="city"
                  type="text"
                  component={renderField}
                  label="Venue City"
                />
              </fieldset>
              <fieldset className="form-group">
                <Field
                  name="postcode"
                  type="text"
                  component={renderField}
                  label="Venue Postcode"
                />
              </fieldset>
              <fieldset className="form-group">
                <Field
                  name="country"
                  type="text"
                  component={renderField}
                  label="Venue Country"
                />
              </fieldset>
              <fieldset className="form-group">
                <Field
                  name="latitude"
                  type="text"
                  component={renderField}
                  label="Venue Latitude"
                />
              </fieldset>
              <fieldset className="form-group">
                <Field
                  name="longitude"
                  type="text"
                  component={renderField}
                  label="Venue Longitude"
                />
              </fieldset>
            </div>
          </form>
        </div>
      )
    }
  }
}

function mapStateToProps(state) {
  return {
    venue: state.venue.item,
    loading: state.venue.loading,
  }
}

export default connect(mapStateToProps, actions)(form(VenueEdit))



/** WEBPACK FOOTER **
 ** ./src/components/venues/edit.js
 **/